<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				{{ $t('goods.upload-images') }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<b-container>
			<p v-if="photoUploadError" style="color: red;">{{ photoUploadError }}</p>
			<p v-if="photoDeleteError" style="color: red;">{{ photoDeleteError }}</p>
			<b-row>
				<b-col cols="3"
					   class="mb-2 image-wrapper"
					   v-for="image in currentEditingItem.images"
					   :key="image.id"
					   @click="setMain(image.id)"
						>
					<i v-if="currentEditingItem.mainPhotoId === image.id" class="fa fa-check"></i>
					<i v-else @click.stop="deletePhoto(image.id)" class="fa fa-close"></i>
					<img class="img-fluid w-100 img-thumbnail mb-2" :src="imageUrl + image.id">
				</b-col>
				<b-col cols="3">
					<div class="upload-wrapper" size="sm" variant="primary">
						<i class="fa fa-plus"></i>
						<input type="file" @input="upload">
					</div>
					<b-spinner class="ml-2" v-if="loading" small></b-spinner>
				</b-col>
			</b-row>


		</b-container>
	</div>
</template>

<script>
    import GoodsService from "../../../../services/goods.service";
	import { mapActions, mapState } from 'vuex'

	export default {
        name: 'Photos',

		props: {},

		data() {
        	return {
        		loading: false,
			}
		},
		computed: {
        	imageUrl() {
        		return process.env.VUE_APP_ROOT_API + '/item/photo/'
			},
			...mapState('goods', [
				'currentEditingItem', 'photoUploadError',
				'photoDeleteError'
			])
		},
		methods: {
        	...mapActions('goods', [
        		'setMainPhotoById', 'uploadPhotoForCurrentItem',
				'deletePhotoById'
			]),

			cancel() {
				this.$emit('close', true);
			},
			async upload($event) {
				this.loading = true;
				const fileList = $event.target.files;
				const file = fileList[0];
				const form = new FormData();
				form.append('itemId', this.currentEditingItem.id);
				form.append('upload', file, file.name);
				await this.uploadPhotoForCurrentItem(form);
				this.loading = false;
				if (!this.photoUploadError) {
					if (this.currentEditingItem.images.length === 1) {
						this.setMain(this.currentEditingItem.images[0].id);
					}
				}
			},
			async setMain(id) {
				let itemIdAndPhotoId = {
					itemId: this.currentEditingItem.id,
					photoId: id
				};
				await this.setMainPhotoById(itemIdAndPhotoId);
			},
			async deletePhoto(id) {
				let itemIdAndPhotoId = {
					itemId: this.currentEditingItem.id,
					photoId: id
				};
				await this.deletePhotoById(itemIdAndPhotoId);
			}
		}
    }
</script>

<style scoped lang="scss">
	.upload-wrapper{
		position: relative;
		overflow: hidden;
		border: 2px solid #e1e1e1;
		height: 200px;
		text-align: center;
	}
	.upload-wrapper i.fa{
		position: absolute;
		color: #e1e1e1;
		font-size: 50px;
		left: calc(50% - 25px);
		top: calc(50% - 25px)
	}
	.upload-wrapper input{
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		opacity: 0;
	}
	.image-wrapper{
		position: relative;
		cursor: pointer;
	}
	.image-wrapper i.fa{
		position: absolute;
		right: 15px;
		color: #fff;
		top: 0;
		padding: 5px;
		border: 5px solid #08772f;
		background: #4dbd74;
		&.fa-close {
			border: .5px solid red;
			background: lightcoral;
		}
	}
</style>
